import Layout from '@/layout'

const miniProgramRouter = {
  path: '/myShop',
  component: Layout,
  children: [
    {
      path: '/myShop/register',
      name: 'shopRegister',
      meta: {
        title: '商铺注册',
      },
      component: () => import('@/views/myShop/register.vue'),
    },
    {
      path: '/myShop/shopPage',
      name: 'shopPage',
      meta: {
        title: '商铺列表',
      },
      component: () => import('@/views/myShop/shopPage.vue'),
    },
    {
      path: '/shopOrderList/:storeId',
      name: 'wxShopOrderList',
      meta: {
        title: '商铺订单列表',
      },
      component: () => import('@/views/shoph5/orderList/shopList.vue'),
    },
  ],
}

export default miniProgramRouter
